import { useState } from 'react'
import {
  DEFAULT_SALES_EVOLUTION_CHART_QUERY,
  resolveSalesEvolutionRange,
  type SalesEvolutionChartQuery,
  type SalesEvolutionPeriodId,
} from '../lib/sales-evolution'

type SalesEvolutionChartState = SalesEvolutionChartQuery & {
  selectPeriod: (next: SalesEvolutionPeriodId) => void
  setCustomFrom: (value: string) => void
  setCustomTo: (value: string) => void
}

export function useSalesEvolutionChart(): SalesEvolutionChartState {
  const [period, setPeriod] = useState<SalesEvolutionPeriodId>(
    DEFAULT_SALES_EVOLUTION_CHART_QUERY.period
  )
  const [customFrom, setCustomFrom] = useState(
    DEFAULT_SALES_EVOLUTION_CHART_QUERY.customFrom
  )
  const [customTo, setCustomTo] = useState(DEFAULT_SALES_EVOLUTION_CHART_QUERY.customTo)

  const selectPeriod = (next: SalesEvolutionPeriodId) => {
    if (next === 'custom' && (!customFrom || !customTo)) {
      const fallback = resolveSalesEvolutionRange('30d', { from: '', to: '' }, new Date())
      setCustomFrom(fallback.dateFrom)
      setCustomTo(fallback.dateTo)
    }
    setPeriod(next)
  }

  return {
    period,
    customFrom,
    customTo,
    selectPeriod,
    setCustomFrom,
    setCustomTo,
  }
}
